module.exports = __webpack_public_path__ + "static/media/ASLMS 2021 Talking Points2_1617113380621.ff2f0b57.docx";